import { defineComponent as _defineComponent } from 'vue'
import { makeFormModel } from 'ah-common-lib/src/form/helpers';
import { emailField, passwordField } from 'ah-common-lib/src/form/models';
import { required } from '@vuelidate/validators';
import { sameAsField } from 'ah-common-lib/src/form/validators';
import { computed, reactive, ref } from 'vue';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { getServices } from '@/app/services';
import { useToast } from 'ah-common-lib/src/toast';
import { useRouter } from 'vue-router/composables';
import { FormDefinition } from 'ah-common-lib/src/form/interfaces';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPasswordView',
  props: { token: { type: String, required: true } },
  setup(__props) {

const props = __props;



const resetPasswordFormDef = reactive<FormDefinition>({
  form: makeFormModel({
    name: 'resetPasswordForm',
    title: 'Reset Password',
    fieldType: 'form',
    fields: [
      emailField('email', 'Email', { autocomplete: 'username', hidden: true, required: false }),
      passwordField('password', 'Password', true, { allowShowPassword: true }),
      passwordField(
        'passwordConfirm',
        'Confirm new password',
        false,
        {
          autocomplete: 'new-password',
        },
        {
          required,
          passwordMatch: sameAsField('password'),
        }
      ),
    ],
  }),
  validation: null,
});

const router = useRouter();

const toast = useToast();

const email = ref<string>('');

const requestManager = useRequestManager().manager;

const services = getServices();

function getEmailForPasswordResetToken() {
  requestManager
    .sameOrCancelAndNew(
      'getEmailForPasswordResetToken',
      services.account.getEmailForPasswordResetToken(props.token!),
      props.token
    )
    .subscribe(
      (response) => {
        email.value = response.email;
        resetPasswordFormDef.form.email = email.value;
      },
      () => {
        toast.error('Error with token provided.');
        router.replace('/');
      }
    );
}

getEmailForPasswordResetToken();

function submit() {
  const payload = {
    email: email.value,
    token: props.token!,
    newPassword: resetPasswordFormDef.form.password,
  };

  requestManager
    .sameOrCancelAndNew('confirmResetPassword', services.account.confirmResetPassword(payload), payload)
    .subscribe(() => {
      toast.success('Password reset succesful.');
      router.push('/login');
    });
}

const loading = computed(() => requestManager.requestStates.confirmResetPassword === 'pending');

return { __sfc: true,props, resetPasswordFormDef, router, toast, email, requestManager, services, getEmailForPasswordResetToken, submit, loading }
}

})